import { CAMPAIGN_PRODUCT_ADS_TOUR_GUIDE, ITEM_REPRICING_TOUR_GUIDE } from 'src/app/core/constants/tour-guide.constant';
import { version } from '../../package.json';

export const environment = {
  version,
  production: true,
  rollbarToken: '21f100a9dfcf41f69e96b04dc207d202',
  pusher: {
    PUSHER_API_KEY: 'b331c28ad486f61595b5',
    PUSHER_API_CLUSTER: 'mt1'
  },
  AdsBaseURL: 'https://advertising.amazon.com/cm/sp/campaigns/',
  calendlyUrl: 'https://calendly.com/forecastrx-support/forecastrx-onboarding',
  calendlyMeetingSupportUrl: 'https://calendly.com/d/g7b-h8r-wt5/support-meeting',
  calendlyFirstRegistrationUrl: 'https://calendly.com/d/cpz4-q59-hjr/forecastrx-company-setup',
  csvboxLicenseKeys: {
    baseUrl: 'https://my.inventoryoptimizer.ai',
    bucketName: 'stockaid',
    csv: {
      item: 'TPZufbwfu4CUXARI1aPufOrnS4ZDaY',
      supplier: 'nK9m9rcoclecHTapC8HIwJaoek1pbb',
      demand: 'gfsYRdYcOp7MCOr8DiyvHA94goFl2J',
      supply: 'DDA0xXAUwiFIOoTMGL7WQCYA0qvTNe',
      bom: 'cGof1HGzjGlkwZBga3slZNLSB0T0WF',
      'historyOverride': 'etjkPuFSDqVZnChRWicJKoeDRDFm83',
      itemsite: '0FNuBEb5f39Ld1bEm4KEHMVLSeo2GN',
      forecastedHistorySetting: '7cpV5A5f41amKoRinr8SoBL4lVmUgg'
    },
    asc: {
      item: 'y4qy6S5KPBdRrdXMYnznwPuhtIsGOt',
      supplier: 'foU4TjKj2ML31bqtWUcGTYsNATPKWR',
      supply: 'ZidcOV6d8GDqITovsN29bbhCo0bDK3',
      bom: 'cGof1HGzjGlkwZBga3slZNLSB0T0WF',
      shipmentItem: 'vQ1dgFrvr2eYRIGzS9vUio3bQw1NjW',
      'historyOverride': 'etjkPuFSDqVZnChRWicJKoeDRDFm83',
      forecastedHistorySetting: '7cpV5A5f41amKoRinr8SoBL4lVmUgg',
      shipmentItemRS: 'xmlS7nSQOYIMzNijqqrSceX5C2Hnbc'
    },
    qb: {
      item: '2JRVSP8VYkuSOQqpxLJ2NUIJ9EXZor',
      supplier: '3Udqz28SGl4hrj5XJfMff1fn3F3wlY',
      'historyOverride': 'etjkPuFSDqVZnChRWicJKoeDRDFm83',
      forecastedHistorySetting: '7cpV5A5f41amKoRinr8SoBL4lVmUgg'
    },
    sfy: {
      item: 'V1v6bC5STGLmuL0Vra47Sx0blESdGr',
      supplier: 'kfWtkkdV3muXMJRNYVjCXm7yEk2ipL',
      supply: 'KjlzS6qsBftzM4he3cSQ5YoYLycG7T',
      bom: 'BaELGV76IWCi3ngIOnZQBg5cHEUbaG',
    },
    ship_station: {
      forecastedHistorySetting: '7cpV5A5f41amKoRinr8SoBL4lVmUgg'
    }
  },
  newCsvboxLicenseKeys: {
    csv: {
      supplier: 'sf4jVkHKIuExA59cyxPqNvznXwKJ0o',
      item: 'w8L2BWzA7wMMhMtFXza8QZlW1mkzn0',
      demand: 'QlLF1HBa3z4qPivpPLPN5ZWNSarttn',
      supply: 'nKj7hb4D87TYvoCV0nDErEI9neFtiH',
      bom: 'ws6C3uBG4B4r54MiGNGZ4FxdNqSV5N'
    },
    asc: {
      supplier: 'd0dkatAxKlAskgNRCdWBTVzkWhjNmI',
      item: 'pj36GVGzZ1lNPUe3ku57iytmbeM0CY',
      supply: 'ORVCvb0BlAoyB8TWp97vq6Kb3y0OJq',
      bom: 'ws6C3uBG4B4r54MiGNGZ4FxdNqSV5N',
      itemPricingRecommendation: 'BRf6HJCE4DfqWthG668cAGqpqTjDWs',
      campaignProductAd: 'vc65fYoEVa78B1N4Xq6L7Bbx06ZUq2'
    },
    qb: {
      supplier: 'sf4jVkHKIuExA59cyxPqNvznXwKJ0o',
      item: 'w8L2BWzA7wMMhMtFXza8QZlW1mkzn0'
    },
    ship_station: {
      supplier: 'sf4jVkHKIuExA59cyxPqNvznXwKJ0o',
      bom: 'ws6C3uBG4B4r54MiGNGZ4FxdNqSV5N',
      item: 'q8x7hdIwCRaeK6iEklEI6wyoLpJZHl',
      supply: '6wlzEiAqcCfQtYqeeW3ip3eOnaNXnR',
    }
  },
  isGoogleTagEnabled: true,
  isRewardfulEnabled: true,
  s3PublicBucketUrl: 'https://stockaid-public.s3.amazonaws.com',
  sendConfirmEmailExpires: 300,
  apiV2: {
    url: 'https://etl.inventoryoptimizer.ai'
  },
  shopify: {
    installUrl: ''
  },
  captchaScriptUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
  captchaSiteKey: '0x4AAAAAACm-cQRAssNBeqBL',
  captchaSites: ['/account/signin','/account/registration','/account/forgot'],
  enableCaptcha: true,
  betaNewFeature:{
    title: 'BETA',
    enableFeatureRequestLink: 'https://support.inventoryoptimizer.ai/hc/en-us/requests/new',
        guidelineAds: CAMPAIGN_PRODUCT_ADS_TOUR_GUIDE.ASC,
    guidelineItemsRepricing: ITEM_REPRICING_TOUR_GUIDE.ASC  
  },

  showRoutineSecurityMessage: true,
  customReportButtonEnableDelaySeconds: 180,
  guidelineModalMinRequiredItems: 10000,
};
